function easeOutCubic(t) {
  return 1 - Math.pow(1 - t, 3);
}

function formatCounter(value, suffix) {
  return `${value}${suffix || ''}`;
}

function animateCounter(el) {
  const target = Number(el.getAttribute('data-count-target') || '0');
  const suffix = el.getAttribute('data-count-suffix') || '';
  if (!Number.isFinite(target)) return;

  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reduceMotion) {
    el.textContent = formatCounter(target, suffix);
    return;
  }

  el.classList.add('is-counting');
  let dotFrame = 0;
  const dotsTimer = window.setInterval(() => {
    dotFrame = (dotFrame + 1) % 4;
    el.textContent = '.'.repeat(dotFrame || 1);
  }, 90);

  window.setTimeout(() => {
    window.clearInterval(dotsTimer);

    const duration = 1200;
    const startAt = performance.now();

    const tick = (now) => {
      const progress = Math.min(1, (now - startAt) / duration);
      const eased = easeOutCubic(progress);
      // Small flicker-like acceleration in early phase.
      const noisy = progress < 0.25 ? eased * (0.9 + Math.random() * 0.08) : eased;
      const value = Math.min(target, Math.round(target * noisy));
      el.textContent = formatCounter(value, suffix);

      if (progress < 1) {
        requestAnimationFrame(tick);
      } else {
        el.textContent = formatCounter(target, suffix);
        el.classList.remove('is-counting');
        el.classList.add('is-settled');
      }
    };

    requestAnimationFrame(tick);
  }, 280);
}

export function initStatsCounters() {
  const counters = Array.from(document.querySelectorAll('[data-counter]'));
  if (!counters.length) return;

  const observer = new IntersectionObserver(
    (entries) => {
      for (const entry of entries) {
        if (!entry.isIntersecting) continue;
        const el = entry.target;
        animateCounter(el);
        observer.unobserve(el);
      }
    },
    { threshold: 0.35 }
  );

  for (const counter of counters) observer.observe(counter);
}
